/* eslint-disable react/jsx-no-bind */
import React, { useState } from 'react';
import {
  Formik, Form, FormikProps, FormikValues,
} from 'formik';
import {
  Layout, Button,
} from 'antd';
import { useHistory } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import * as Yup from 'yup';

import { useActions } from '../../providers/actions-provider/actions.context';
import FormControl from '../../lib/form-control';
import LogoButton from '../../lib/logo-button';
import { SIGN_IN_PATH } from '../../routing/paths.constants';

const forgotPasswordScheme = Yup.object().shape({
  userNameOrEmail: Yup.string().required('Email or username is required'),
});

const changePasswordSchema = Yup.object().shape({
  otp: Yup.number()
    .typeError('OTP must be a number')
    .required('OTP is required'),
  newPassword: Yup.string()
    .required('New password is required'),
  confirmPassword: Yup.string()
    .required('Confirm password is required')
    .oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
});

const ForgotPassword = (): JSX.Element => {
  const { userActions } = useActions();
  const { replace } = useHistory();
  const [passwordSent, setPasswordSent] = useState(false);
  const [passwordChanged, setPasswordChanged] = useState(true);

  const goToSignIn = () => {
    replace(SIGN_IN_PATH);
  };

  return (
    <Layout className="auth-layout auth-layout__forgot-pass">
      <div className="form">
        <LogoButton />
        {passwordSent ? (
          <Formik
            initialValues={{
              otp: '',
              newPassword: '',
              confirmPassword: '',
            }}
            onSubmit={async (values) => {
              const changed = await userActions.changeForgottenPassword(
                values.otp, values.newPassword,
              );
              if (changed) {
                goToSignIn();
              }
              setPasswordChanged(false);
            }}
            validationSchema={changePasswordSchema}
            enableReinitialize
          >
            {({ isSubmitting }: FormikProps<FormikValues>) => (
              <Form className="auth-layout__form">
                <h2 className="auth-layout__form-title form__reset-title">Check your mail</h2>
                <p className="form__text">Please check your email. Find and enter your one time password (OTP) here.</p>
                {
                  !passwordChanged
                    ? <p className="form__text" style={{ color: 'red' }}>Error while trying to change password, review the OTP please</p>
                    : null
                }
                <FormControl
                  name="otp"
                  label="One time password (OTP)"
                  type="text"
                  inputClassName="form__input"
                  wrapperClassName="form__label"
                />
                <FormControl
                  name="newPassword"
                  label="New password"
                  type="password"
                  inputClassName="form__input"
                  wrapperClassName="form__label"
                />
                <FormControl
                  name="confirmPassword"
                  label="Confirm password"
                  type="password"
                  inputClassName="form__input"
                  wrapperClassName="form__label"
                />
                <Button
                  className="auth-layout__form-submit"
                  type="default"
                  htmlType="submit"
                  loading={isSubmitting}
                >
                  Submit
                </Button>
                {/* <button
                  type="submit"
                  className="auth-layout__form-submit"
                >
                  Submit
                </button> */}
              </Form>
            )}
          </Formik>
        ) : (
          <Formik
            initialValues={{
              userNameOrEmail: '',
            }}
            onSubmit={(values) => {
              userActions.forgotPassword(values);
              setPasswordSent(true);
            }}
            validationSchema={forgotPasswordScheme}
            enableReinitialize
          >
            <Form className="auth-layout__form">
              <button
                type="button"
                className="form__go-back"
                onClick={goToSignIn}
              >
                <ArrowLeftOutlined />
                Back
              </button>
              <h2 className="auth-layout__form-title">Forgot password</h2>
              <p className="form__text">Enter your username or email associated with your account.</p>
              <FormControl name="userNameOrEmail" label="Email or username" type="text" inputClassName="form__input" wrapperClassName="form__label" />
              <button type="submit" className="auth-layout__form-submit">
                Send Instructions
              </button>
            </Form>
          </Formik>
        )}
      </div>
    </Layout>
  );
};

ForgotPassword.displayName = 'ForgotPassword';

export default ForgotPassword;
